import { Button } from '@mui/material';
import styled from 'styled-components';

import TextField from 'components/v2/TextField';
import { COLORS } from 'theme';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledTextField = styled(TextField)`
  .MuiFormHelperText-root {
    text-align: left;
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  height: ${({ theme }) => theme.heights.s};
  > button {
    gap: ${({ theme }) => theme.spacing.s2};
  }
`;

export const StyledActionButton = styled(Button)`
  &&& {
    padding: ${({ theme: { spacing } }) => `${spacing.s1} ${spacing.s2}`};
    gap: 0px;
    color: ${COLORS.black60};
    font-size: ${({ theme }) => theme.fontSize.body2};
  }
  svg {
    path {
      fill: ${COLORS.black40};
    }
  }

  &:hover {
    color: ${COLORS.kinetikBlack};
    svg {
      path {
        fill: ${COLORS.kinetikBlack};
      }
    }
  }
`;
